import { Navigate } from 'react-router-dom'
import { ReactNode } from 'react'
import { useLicense } from '@/hooks/useLicense'

interface PipelineLicenseGateProps {
  children: ReactNode
}

// PipelineLicenseGate blocks the pipeline editor routes when the license is
// expired. The running pipelines keep serving traffic in the background; only
// the editor is locked until the license is renewed. The backend (synstream
// token gate) enforces this too; this guard is the matching UI behaviour.
export default function PipelineLicenseGate({ children }: PipelineLicenseGateProps) {
  const { expired, loading } = useLicense()

  if (!loading && expired) {
    return <Navigate to="/plans?reason=license_expired" replace />
  }

  return <>{children}</>
}
